/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Table, TableColumnsType, Tooltip } from "antd";
import { WODetailType } from "../../../ducks/types";
import Input from "antd/es/input/Input";
import { DownloadIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
// import Filters from "./Components/Filters";

interface PropsType {
  woDetailData: WODetailType | null;
}

export default function JobCosting(props: PropsType) {
  const { woDetailData } = props;
  // const [pagination, setPagination] = useState(1);
  // const [limit, setLimit] = useState(10);
  // const [archived, isArchived] = useState(false);

  // const [filters, setFilters] = useState<{
  //   type: undefined | string;
  //   status: undefined | string[];
  //   state: undefined;
  //   city: undefined;
  //   last_user_activity: string[] | undefined;
  //   onboarding_complete_date: string[] | undefined;
  //   search_text: undefined | string;
  // }>({
  //   type: undefined,
  //   status: undefined,
  //   state: undefined,
  //   city: undefined,
  //   last_user_activity: undefined,
  //   onboarding_complete_date: undefined,
  //   search_text: undefined,
  // });

  const columns: TableColumnsType = [
    {
      title: "Direct cost",
      dataIndex: "name",
      fixed: "left",
      width: 240,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            text
          )
        ) : (
          "-"
        ),
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Unit cost",
      dataIndex: "unit_cost",
      width: 120,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()}`
          )
        ) : (
          "-"
        ),
      align: "right",
      sorter: (a, b) => a?.unit_cost?.localeCompare(b?.unit_cost),
      className: "right-aligned-sorter",
    },
    {
      title: "Est. hrs / qty",
      dataIndex: "estimated_hrs_or_qty_value",
      width: 160,
      render: (text, record) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()} ${
              record?.estimated_hrs_or_qty_unit
            }`
          )
        ) : (
          "-"
        ),
      align: "right",
      className: "right-aligned-sorter",
      sorter: (a, b) =>
        a?.estimated_hrs_or_qty_value?.localeCompare(
          b?.estimated_hrs_or_qty_value
        ),
    },
    {
      title: "Projected qty",
      dataIndex: "projected_qty",
      width: 160,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            text
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",

      sorter: (a, b) => a?.projected_qty?.localeCompare(b?.projected_qty),
    },
    {
      title: "To date hrs / qty",
      dataIndex: "to_date_hrs_or_qty_value",
      width: 160,
      render: (text, record) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `${text} ${record?.to_date_hrs_or_qty_unit}`
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",

      sorter: (a, b) => a?.to_date_hrs_qty?.localeCompare(b?.to_date_hrs_qty),
    },
    {
      title: "Est. cost",
      dataIndex: "estimated_cost",
      width: 120,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()}`
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.estimated_cost?.localeCompare(b?.estimated_cost),
    },
    {
      title: "Projected cost",
      dataIndex: "projected_cost",
      width: 150,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()}`
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.projected_cost?.localeCompare(b?.projected_cost),
    },
    {
      title: "To date cost",
      dataIndex: "to_date_cost",
      width: 150,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()}`
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.to_date_cost?.localeCompare(b?.to_date_cost),
    },
    {
      title: "Total price",
      dataIndex: "total_price",
      width: 120,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            `$${Number(text?.toFixed(2))?.toLocaleString()}`
          )
        ) : (
          "-"
        ),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.total_price?.localeCompare(b?.total_price),
    },
    {
      title: "Project GM, %",
      dataIndex: "projected_gross_margin_perc",
      width: 150,
      render: (text) =>
        text ? (
          text === "empty_row" ? (
            <div style={{ height: 20 }} />
          ) : (
            text
          )
        ) : (
          "-"
        ),
      align: "right",
      className: "right-aligned-sorter",
      sorter: (a, b) =>
        a?.projected_gross_margin_perc?.localeCompare(
          b?.projected_gross_margin_perc
        ),
    },
  ];

  const transformJobCostings = (data: []) => {
    const manHours: any[] = data.filter(
      (item: { type: string }) => item.type === "MAN_HOURS"
    );
    const materials: any[] = data.filter(
      (item: { type: string }) => item.type === "MATERIALS"
    );
    const others = data.filter(
      (item: { type: string }) =>
        item.type !== "MAN_HOURS" && item.type !== "MATERIALS"
    );

    const result: any[] = [];

    // --- Insert Man-hours section ---
    if (manHours.length > 0) {
      const unitCost = manHours.reduce((sum, i) => sum + (i.unit_cost || 0), 0);
      const projectedQty = manHours.reduce(
        (sum, i) => sum + (i.projected_qty || 0),
        0
      );
      const totalEstimatedHrs = manHours.reduce(
        (sum, i) => sum + (i.estimated_hrs_or_qty_value || 0),
        0
      );
      const totalToDateHrs = manHours.reduce(
        (sum, i) => sum + (i.to_date_hrs_or_qty_value || 0),
        0
      );
      const totalEstimatedCost = manHours.reduce(
        (sum, i) => sum + (i.estimated_cost || 0),
        0
      );
      const totalProjectedCost = manHours.reduce(
        (sum, i) => sum + (i.projected_cost || 0),
        0
      );
      const totalToDateCost = manHours.reduce(
        (sum, i) => sum + (i.to_date_cost || 0),
        0
      );
      const totalPrice = manHours.reduce(
        (sum, i) => sum + (i.total_price || 0),
        0
      );

      // pick unit dynamically from payload (to_date_hrs_or_qty_unit)
      const estimated_hrs_or_qty_unit =
        manHours.find((i) => i.estimated_hrs_or_qty_unit)
          ?.estimated_hrs_or_qty_unit || "";
      const to_date_hrs_or_qty_unit =
        manHours.find((i) => i.to_date_hrs_or_qty_unit)
          ?.to_date_hrs_or_qty_unit || "";

      result.push({
        name: "Man-hours",
        unit_cost: unitCost,
        estimated_hrs_or_qty_value: totalEstimatedHrs,
        estimated_hrs_or_qty_unit: estimated_hrs_or_qty_unit,
        projected_qty: projectedQty,
        to_date_hrs_or_qty_value: `${totalToDateHrs}`,
        to_date_hrs_or_qty_unit: to_date_hrs_or_qty_unit,
        estimated_cost: totalEstimatedCost,
        actual_cost: totalEstimatedCost,
        projected_cost: totalProjectedCost,
        to_date_cost: totalToDateCost,
        total_price: totalPrice,
        projected_gross_margin_perc:
          manHours.find((i) => i.projected_gross_margin_perc)
            ?.projected_gross_margin_perc || "",
      });
      result.push(...manHours);
    }

    if (manHours.length > 0 && materials.length > 0) {
      result.push({
        name: "empty_row",
        unit_cost: "empty_row",
        estimated_hrs_or_qty_value: "empty_row",
        estimated_hrs_or_qty_unit: "empty_row",
        projected_qty: "empty_row",
        to_date_hrs_or_qty_value: "empty_row",
        to_date_hrs_or_qty_unit: "empty_row",
        estimated_cost: "empty_row",
        actual_cost: "empty_row",
        projected_cost: "empty_row",
        to_date_cost: "empty_row",
        total_price: "empty_row",
        projected_gross_margin_perc: "empty_row", // can also calculate if needed
      });
    }

    // --- Insert Materials section ---
    if (materials.length > 0) {
      const unitCost = materials.reduce(
        (sum, i) => sum + (i.unit_cost || 0),
        0
      );
      const projectedQty = materials.reduce(
        (sum, i) => sum + (i.projected_qty || 0),
        0
      );
      const totalEstimatedHrs = materials.reduce(
        (sum, i) => sum + (i.estimated_hrs_or_qty_value || 0),
        0
      );
      const totalToDateHrs = materials.reduce(
        (sum, i) => sum + (i.to_date_hrs_or_qty_value || 0),
        0
      );
      const totalEstimatedCost = materials.reduce(
        (sum, i) => sum + (i.estimated_cost || 0),
        0
      );
      const totalProjectedCost = materials.reduce(
        (sum, i) => sum + (i.projected_cost || 0),
        0
      );
      const totalToDateCost = materials.reduce(
        (sum, i) => sum + (i.to_date_cost || 0),
        0
      );
      const totalPrice = materials.reduce(
        (sum, i) => sum + (i.total_price || 0),
        0
      );

      // pick unit dynamically from payload (to_date_hrs_or_qty_unit)
      const estimated_hrs_or_qty_unit =
        materials.find((i) => i.estimated_hrs_or_qty_unit)
          ?.estimated_hrs_or_qty_unit || "";
      const to_date_hrs_or_qty_unit =
        materials.find((i) => i.to_date_hrs_or_qty_unit)
          ?.to_date_hrs_or_qty_unit || "";
      result.push({
        name: "Materials",
        unit_cost: unitCost,
        estimated_hrs_or_qty_value: totalEstimatedHrs,
        estimated_hrs_or_qty_unit: estimated_hrs_or_qty_unit,
        projected_qty: projectedQty,
        to_date_hrs_or_qty_value: `${totalToDateHrs}`,
        to_date_hrs_or_qty_unit: to_date_hrs_or_qty_unit,
        estimated_cost: totalEstimatedCost,
        actual_cost: totalEstimatedCost,
        projected_cost: totalProjectedCost,
        to_date_cost: totalToDateCost,
        total_price: totalPrice,
        projected_gross_margin_perc:
          manHours.find((i) => i.projected_gross_margin_perc)
            ?.projected_gross_margin_perc || "", // can also calculate if needed
      });
      result.push(...materials);
    }

    // --- Add any remaining types (if needed) ---
    result.push(...others);

    return result;
  };

  // const dummyArray = [
  //   {
  //     direct_cost: "Man-hours",
  //     unit_cost: "",
  //     est_hrs_qty: "800 hrs",
  //     projected_qty: "1050",
  //     to_date_hrs_qty: "550 hrs",
  //     est_cost: "$1,500",
  //     actual_cost: "$1,495",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$115",
  //     total_price: "$2,419",
  //     project_gm: "38%",
  //   },
  //   {
  //     direct_cost: "Team B - Carlos E.",
  //     unit_cost: "$40",
  //     est_hrs_qty: "200 hrs",
  //     projected_qty: "1050",
  //     to_date_hrs_qty: "150 hrs",
  //     est_cost: "$1,500",
  //     actual_cost: "$1,495",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$115",
  //     total_price: "$2,419",
  //     project_gm: "38%",
  //   },
  //   {
  //     direct_cost: "Materials",
  //     unit_cost: "",
  //     est_hrs_qty: "",
  //     projected_qty: "",
  //     to_date_hrs_qty: "",
  //     est_cost: "$7,700",
  //     actual_cost: "$7,700",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$31,000",
  //     total_price: "$15,400",
  //     project_gm: "50%",
  //   },
  //   {
  //     direct_cost: "Sod",
  //     unit_cost: "$0.5",
  //     est_hrs_qty: "5,000 sf",
  //     projected_qty: "5000",
  //     to_date_hrs_qty: "5000 sf",
  //     est_cost: "$2500",
  //     actual_cost: "$2500",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$2500",
  //     total_price: "$5000",
  //     project_gm: "50%",
  //   },
  //   {
  //     direct_cost: "Fertilizer",
  //     unit_cost: "$0.5",
  //     est_hrs_qty: "5,000 sf",
  //     projected_qty: "5000",
  //     to_date_hrs_qty: "5000 sf",
  //     est_cost: "$2500",
  //     actual_cost: "$2500",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$2500",
  //     total_price: "$5000",
  //     project_gm: "50%",
  //   },
  //   {
  //     direct_cost: "Pine straw",
  //     unit_cost: "$0.5",
  //     est_hrs_qty: "5,000 sf",
  //     projected_qty: "5000",
  //     to_date_hrs_qty: "5000 sf",
  //     est_cost: "$2500",
  //     actual_cost: "$2500",
  //     projected_cost: "$1,495",
  //     to_date_cost: "$2500",
  //     total_price: "$5000",
  //     project_gm: "50%",
  //   },
  // ];

  return (
    <div className="workOrderMaterial">
      {/* <h3 style={{ position: "absolute", top: "-45px" }}> Job Costing </h3> */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h3> Job Costing </h3>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div className="filterSearch">
            <Input prefix={<SearchIcon />} placeholder="Search" allowClear />
          </div>
          <div className="filterDownload">
            <Tooltip title="Export the list of job costing">
              <Button
                icon={<DownloadIcon />}
                style={{ height: "36px", width: "36px" }}
                disabled={true}
              />
            </Tooltip>
          </div>
        </div>
      </div>

      <Table
        style={{ marginTop: "0px" }}
        className="job_costing_table"
        columns={columns}
        dataSource={transformJobCostings(woDetailData?.jobCostings || []) || []}
        scroll={{ x: "max-content" }}
        pagination={false}
        // rowKey="index"
        rowKey="id"
        rowClassName={(record) => {
          if (record.name === "Man-hours" || record.name === "Materials") {
            return "bold_row";
          }
          return "";
        }}
        summary={() => (
          <Table.Summary fixed="bottom">
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={5}>
                Service total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="right">
                {(() => {
                  const rows =
                    transformJobCostings(woDetailData?.jobCostings || []) || [];
                  const sum = rows.reduce(
                    (acc, r) => acc + (Number(r.estimated_cost) || 0),
                    0
                  );
                  return `$${sum.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                })()}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right">
                {(() => {
                  const rows =
                    transformJobCostings(woDetailData?.jobCostings || []) || [];
                  const sum = rows.reduce(
                    (acc, r) => acc + (Number(r.projected_cost) || 0),
                    0
                  );
                  return `$${sum.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                })()}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">
                {(() => {
                  const rows =
                    transformJobCostings(woDetailData?.jobCostings || []) || [];
                  const sum = rows.reduce(
                    (acc, r) => acc + (Number(r.to_date_cost) || 0),
                    0
                  );
                  return `$${sum.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                })()}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right">
                {(() => {
                  const rows =
                    transformJobCostings(woDetailData?.jobCostings || []) || [];
                  const sum = rows.reduce(
                    (acc, r) => acc + (Number(r.total_price) || 0),
                    0
                  );
                  return `$${sum.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                })()}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">
                <span style={{ color: "red" }}> 0% </span>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        sticky={{ offsetHeader: 64 }}
      />
    </div>
  );
}
